import { createContext } from '../Context/index.js';

export const ProfileContext = createContext();

export default ProfileContext;
